import { createStore } from 'vuex'
import router from '@/router/index.js'
import { db, auth } from '@/firebase/FirebaseInit'
import { collection, getDocs, deleteDoc, doc, updateDoc, serverTimestamp, addDoc, onSnapshot} from 'firebase/firestore'
import { signInWithEmailAndPassword } from 'firebase/auth'


import '@fortawesome/fontawesome-free/css/all.css'

export default createStore({
  state: {
    user: null,
    isLoggedIn: false,


    proposalsData: [],
    reminders: [],
    visitorData: [],
    remindersLoaded: null,
    proposalsLoaded: null,
    visitorDataLoaded: null,
    currentProposalArray: [],
    
    isDarkMode: false,
  },
  getters: {
  },
  mutations: {
    TOGGLE_DARK_MODE(state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
    },

    SET_USER (state, payload) {
      if(payload){
        state.user = payload;
      }else{
        state.userInfo = null;
      }
    },

    LOGIN_SUCCESSFUL (state, payload) {
      state.isLoggedIn = true;
    },

    LOGOUT(state) {
      state.isLoggedIn = false;
    },


    SET_PROPOSALS_DATA(state, payload) {
      // console.log('Received payload:', payload);
      // console.log('Sorting proposals...');
      let inserted = false;
      for (let i = 0; i < state.proposalsData.length; i++) {
        if (payload.submissionDateUnix > state.proposalsData[i].submissionDateUnix) {
          state.proposalsData.splice(i, 0, payload);
          inserted = true;
          break;
        }
      }
      if (!inserted) {
        state.proposalsData.push(payload);
      }

    },

    PROPOSALS_LOADED(state) {
      state.proposalsLoaded = true;
    },


    SET_CURRENT_PROPOSAL(state, payload) {
      state.currentProposalArray = state.proposalsData.filter((proposal) => {
        return proposal.proposalId === payload;
      })
    },

    DELETE_PROPOSAL(state, payload) {
      state.proposalsData = state.proposalsData.filter((proposal) => proposal.docId !== payload); 
    },

    SET_REMINDERS(state, reminder) {
      state.reminders.push(reminder);

      // Sort the reminders array based on the timestamp in descending order
      state.reminders.sort((a, b) => b.timestamp - a.timestamp);
    },

    ADD_REMINDER(state, reminder) {
      state.reminders.push(reminder);
    },

    UPDATE_REMINDER_STATUS(state, { index, status }) {
      state.reminders[index].status = status;
    },

    REMOVE_REMINDER(state, index) {
      state.reminders.splice(index, 1);
    },

    REMINDERS_LOADED(state) {
      state.remindersLoaded = true;
    },

    VISITOR_DATA_LOADED(state) {
      state.visitorDataLoaded = true;
    },

    SET_VISITOR_DATA(state, data) {
      state.visitorData = data;
    },




  },
  actions: {
    async LOGIN({ commit }, { email, password }) {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);

        commit('SET_USER', userCredential.user);
        console.log('USER', userCredential.user);

        commit('LOGIN_SUCCESSFUL');
        console.log('Login Successful');

        router.push({ name: 'Dashboard' });

      } catch (error) {
        console.log(error)
        commit('LOGOUT');
      }
    },


    async GET_PROPOSALS({ commit }) {
      const proposalsCollection = collection(db, 'invitations');
    
      // Listen for real-time updates
      const unsubscribe = onSnapshot(proposalsCollection, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            docId: doc.id,
            proposalId: doc.data().proposalId,
            clientName: doc.data().clientName,
            clientEmail: doc.data().clientEmail,
            clientPhoneNumber: doc.data().clientPhoneNumber,
            emailSubject: doc.data().emailSubject,
            clientRequest: doc.data().clientRequest,
            submissionDate: doc.data().submissionDate,
            submissionDateUnix: doc.data().submissionDateUnix,
            requestSubmitted: doc.data().requestSubmitted,
            status: doc.data().status,
          };
    
          // Commit the mutation to update the state
          commit('SET_PROPOSALS_DATA', data);
        });
    
        // Commit a mutation to indicate that proposals are loaded
        commit('PROPOSALS_LOADED');
      });

      return unsubscribe;
    },


    async DELETE_PROPOSAL({commit}, docId) {
      const getProposals = doc(db, 'invitations', docId);
      await deleteDoc(getProposals);
      commit('DELETE_PROPOSAL', docId)
    },

    async ACCEPT_PROPOSAL({ commit }, proposalId) {
      try {
        const proposalRef = doc(db, 'invitations', proposalId);
        await updateDoc(proposalRef, { status: 'Accepted' });

        commit('ACCEPT_PROPOSAL', proposalId);
      } catch (error) {
        console.error('Error updating proposal status:', error);
        // Handle the error as needed
      }
    },

    async DECLINE_PROPOSAL({ commit }, proposalId) {
      try {
        const proposalRef = doc(db, 'invitations', proposalId);
        await updateDoc(proposalRef, { status: 'Declined' });

        commit('DECLINE_PROPOSAL', proposalId);
      } catch (error) {
        console.error('Error updating proposal status:', error);
      }
    },

    async FETCH_REMINDERS({commit, state}) {
      const getData = await getDocs(collection(db, 'to-do'));
      getData.forEach((doc) => {
        if (!state.reminders.some((reminder) => reminder.docId === doc.id)) {
          const data = {
            docId: doc.id,
            note: doc.data().note,
            status: doc.data().status,
            timestamp: doc.data().timestamp, 
          };
          commit('SET_REMINDERS', data);
        }
      });
      commit('REMINDERS_LOADED');
    },
    
    async UPDATE_REMINDER_STATUS({ commit }, { id, index, status }) {
      await updateDoc(doc(db, 'to-do', id), {
        status: status,
      });
    
      // Commit the updated status to the store
      commit('UPDATE_REMINDER_STATUS', { index, status });
    },

    async DELETE_REMINDER({ commit }, { id, index }) {
      try {
        await deleteDoc(doc(db, 'to-do', id));
  
        // Commit the delete action to the store
        commit('REMOVE_REMINDER', index);
      } catch (error) {
        console.error('Error deleting reminder:', error);
      }
    },


    async STORE_VISITOR_DATA({ commit }, visitorData) {
      try {
        const collectionRef = collection(db, 'visitors');
  
        // Add the visitorData object to the collection
        const docRef = await addDoc(collectionRef, {
          ...visitorData,
          timestamp: serverTimestamp(),
        });
  
        // console.log('Visitor data successfully stored:', docRef.id);
        commit('SET_VISITOR_DATA', visitorData);
      } catch (error) {
        // console.error('Error storing visitor data:', error);
      }
    },

    async FETCH_VISITOR_DATA({ commit }) {
      try {
        const collectionRef = collection(db, 'visitors');
        const snapshot = await getDocs(collectionRef);
        const visitorData = snapshot.docs.map(doc => doc.data());
  
        commit('SET_VISITOR_DATA', visitorData);
        commit('VISITOR_DATA_LOADED');
      } catch (error) {
        // console.error('Error fetching visitor data:', error);
      }
    },

    START_VISITOR_LISTENER({ commit }) {
      const collectionRef = collection(db, 'visitors');
  
      // Set up a real-time listener
      const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
        const visitorData = snapshot.docs.map((doc) => doc.data());
        commit('SET_VISITOR_DATA', visitorData);
      });
  
      // This will stop the listener when the component is destroyed
      return unsubscribe;
    },

  },
  modules: {
  }
})
